module.exports = __webpack_public_path__ + "static/media/tanque-rojo_old.bf6f2d00.svg";